import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ResourcesService } from '../resources.service';

@Injectable()
export class SettingsService {
  countries: any[];
  notificationTypes: any[];
  timezones: any[];
  currencies: any[];

  constructor(private _resources: ResourcesService) { }

  getAllRequests(): Observable<any[]> {
    return new Observable((observer) => {
      const isComplete = () => {
        return this.countries !== undefined &&
          this.notificationTypes !== undefined &&
          this.timezones !== undefined &&
          this.currencies !== undefined;
      };

      this.getCountryList().subscribe(
         (countries: any[]) => {
           this.countries = countries;
           observer.next(this.countries);
           if (isComplete()) {
             observer.complete();
           }
         }
      );

      this.getTimeZones().subscribe(
        (timezones: any[]) => {
          this.timezones = timezones;
          observer.next(this.timezones);
          if (isComplete()) {
            observer.complete();
          }
        }
      );

      this.getCurrencies().subscribe(
        (currencies: any[]) => {
          this.currencies = currencies;
          observer.next(this.currencies);
          if (isComplete()) {
            observer.complete();
          }
        }
      );

      this.getNotificationTypeList().subscribe(
        (notifications: any[]) => {
          this.notificationTypes = notifications;
          observer.next(this.notificationTypes);
          if (isComplete()) {
            observer.complete();
          }
        }
      );
    });
  }

  getCountryList(): Observable<any[]> {
    return this._resources.get('country/list', false);
  }

  getNotificationTypeList(): Observable<any[]> {
    return this._resources.get('settings/getNotificationTypeList', true);
  }

  getTimeZones(): Observable<any[]> {
    return this._resources.get('settings/GetTimeZones', false);
  }

  getCurrencies(): Observable<any[]> {
    return this._resources.get('settings/GetCurrencies', false);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/api/resources/settings/settings.service.ts